import { render, staticRenderFns } from "./Edit1.vue?vue&type=template&id=0b3de9d1&scoped=true"
import script from "./Edit1.vue?vue&type=script&lang=js"
export * from "./Edit1.vue?vue&type=script&lang=js"
import style0 from "./Edit1.vue?vue&type=style&index=0&id=0b3de9d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3de9d1",
  null
  
)

export default component.exports